import { render, staticRenderFns } from "./RekapPerMapelUjianHasilPolri.vue?vue&type=template&id=55aced52"
import script from "./RekapPerMapelUjianHasilPolri.vue?vue&type=script&lang=js"
export * from "./RekapPerMapelUjianHasilPolri.vue?vue&type=script&lang=js"
import style0 from "./RekapPerMapelUjianHasilPolri.vue?vue&type=style&index=0&id=55aced52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports